import * as userConstants from "@/core/models/usersAndPermissions";
import { routes } from "@/routing/routes";

const warehouseDispatchRouter = [
  {
    path: routes.warehouseDispatch.path,
    name: routes.warehouseDispatch.name,
    component: () =>
      import(
        /* webpackChunkName: "db-wh-disp" */ "@/apps/dashboard/warehouseDispatch/view/pages/Configuration/Dispatch/WarehouseDispatch.vue"
      ),
    meta: {
      permission: userConstants.ROLE_WAREHOUSE_DISPATCH_RULE_READ,
    },
  },
  {
    path: routes.newWarehouseDispatchRule.path,
    name: routes.newWarehouseDispatchRule.name,
    component: () =>
      import(
        /* webpackChunkName: "db-wh-dispr" */ "@/apps/dashboard/warehouseDispatch/view/pages/Configuration/Dispatch/WarehouseDispatchRule.vue"
      ),
    meta: {
      permission: userConstants.ROLE_WAREHOUSE_DISPATCH_RULE_CREATE,
    },
  },
  {
    path: routes.warehouseDispatchRule.path,
    name: routes.warehouseDispatchRule.name,
    component: () =>
      import(
        /* webpackChunkName: "db-wh-dispr" */ "@/apps/dashboard/warehouseDispatch/view/pages/Configuration/Dispatch/WarehouseDispatchRule.vue"
      ),
    meta: {
      permission: userConstants.ROLE_WAREHOUSE_DISPATCH_RULE_CREATE,
    },
  },
];

export default warehouseDispatchRouter;
